import ImageOptimizer from '@/components/image-optimizer';
import { formatKoreanDate } from '@/lib/date';
import { convertToHyphen, slugify } from '@/lib/utils';
import { ArticleEntity, ArticleType } from '@/services/types/article.type';
import ArrowDetailSvg from '@/svg/detail-arrow.svg';
import Link from 'next/link';

export default function EventHeader({
  id,
  title,
  startDatetime,
  endDatetime,
  viewDatetime,
  subTitle,
  iconText,
  thumbPath,
  iconBcolor,
  iconFcolor,
  board,
}: ArticleEntity) {
  return (
    <Link
      href={
        '/' +
        convertToHyphen(board.type.replace('_training', '')) +
        '/' +
        slugify(title, id)
      }
      className="block transition"
    >
      <div className="desktop:flex-row desktop:items-center desktop:gap-10 flex flex-col gap-6 bg-white">
        <div className="flex gap-4">
          <div className="desktop:h-[320px] relative aspect-[27/16] w-full overflow-hidden rounded-lg">
            <ImageOptimizer
              src={thumbPath}
              alt={title}
              fill
              className="object-cover"
              // sizes="(max-width: 768px) 100px, 120px"
            />
          </div>
        </div>
        <div className="desktop:flex desktop:h-full desktop:grow desktop:flex-col desktop:justify-between flex flex-col">
          <div className="text-level-5 typo-18 desktop:typo-24 desktop:mb-5 mb-[16px] font-semibold">
            {board?.type == ArticleType.EVENT
              ? formatKoreanDate(startDatetime) +
                ' ~ ' +
                (endDatetime ? formatKoreanDate(endDatetime) : '상시진행')
              : formatKoreanDate(viewDatetime)}
          </div>
          <div className="desktop:h-full">
            <div className="text-level-2 typo-26 desktop:typo-36 desktop:max-w-[600px] flex flex-shrink-0 items-center gap-2 font-extrabold">
              <span className="desktop:inline-block min-w-0 truncate">
                {title}
              </span>
              {/* <span className="bg-main-yellow text-level-2 typo-14 rounded-full px-2 py-1 font-bold">
                Best
              </span> */}
              {iconText && (
                <span
                  className="desktop:typo-16 typo-14 ml-1 shrink-0 rounded-full px-[9px] py-1 font-bold"
                  style={{
                    backgroundColor: iconBcolor || 'var(--color-main-yellow)',
                    color: iconFcolor || 'var(--color-level-2)',
                  }}
                >
                  {iconText}
                </span>
              )}
            </div>
            <div className="text-level-3 typo-20 desktop:typo-26 desktop:leading-[38px] desktop:min-h-[68px] mt-[18px] line-clamp-2 leading-snug font-semibold">
              {subTitle}
            </div>
            <div className="desktop:mt-14 desktop:flex desktop:items-center desktop:gap-2 hidden">
              <span className="text-level-5 typo-20 font-semibold">
                자세히보기
              </span>
              <ArrowDetailSvg />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
